import { render } from "./ProductForm.vue?vue&type=template&id=6e847fab"
import script from "./ProductForm.vue?vue&type=script&lang=ts"
export * from "./ProductForm.vue?vue&type=script&lang=ts"
script.render = render

export default script